import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Css/Footer.css";
import BackToTop from "./assets/images/back-to-top.svg";
import AddGameToinstall from "./AddGameToinstall";

const Footer = () => {
  const year = new Date().getFullYear();
  const [showButton, setShowButton] = useState(false);

  // Show button on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <AddGameToinstall />
      <div className="footer_main">
        <ul>
          <li>
            <Link to="#">Free Online Games</Link>
          </li>

          <li>
            <Link to="#">Privacy Policy</Link>
          </li>

          <li>
            <Link to="#">About Us</Link>
          </li>

          <li>
            <Link to="blog">Blog</Link>
          </li>

          <li>
            <Link to="#">Contact Us</Link>
          </li>

          <li>
            <Link to="#">Girl Games</Link>
          </li>

          <li>@ htmlgames4u.com {year}</li>
        </ul>
      </div>

      {/* Back to top button */}
      {showButton && (
        <button className="back-to-top" onClick={scrollToTop}>
          <img src={BackToTop} />
        </button>
      )}
    </>
  );
};
export default Footer;
